module.exports = __webpack_public_path__ + "img/check-circle 1.4f6dcc78.png";